"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_SETTING = void 0;
const __1 = require("..");
exports.SYSTEM_SETTING = __1.ADMIN.child("/systemSetting");
